var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 83,
    viewBox: "0 0 67 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4941 33.9415C58.8671 30.2787 56.5019 26.9912 53.5465 24.2846L51.1078 22.0464C51.025 21.9725 50.9253 21.9201 50.8175 21.8937C50.7097 21.8673 50.5971 21.8678 50.4895 21.8951C50.3819 21.9224 50.2827 21.9757 50.2006 22.0503C50.1184 22.1249 50.0558 22.2186 50.0183 22.3231L48.9288 25.4498C48.25 27.4114 47.0012 29.4148 45.2329 31.3848C45.1156 31.5105 44.9815 31.544 44.8893 31.5524C44.7971 31.5608 44.6546 31.544 44.5289 31.4267C44.4116 31.3261 44.3529 31.1752 44.3613 31.0243C44.6714 25.9779 43.1629 20.2861 39.8609 14.0912C37.1288 8.94425 33.3324 4.92893 28.5889 2.12911L25.1277 0.0921104C24.6751 -0.176136 24.0969 0.175937 24.122 0.704048L24.3064 4.72775C24.4321 7.47728 24.1136 9.90826 23.3594 11.9285C22.4375 14.4014 21.1133 16.6983 19.4204 18.7604C18.2423 20.1935 16.907 21.4898 15.4396 22.6248C11.9055 25.3422 9.03187 28.8241 7.0338 32.8098C5.04066 36.8303 4.00243 41.2567 4 45.7443C4 49.701 4.7794 53.5319 6.32145 57.1448C7.81041 60.6234 9.95915 63.7804 12.6489 66.4413C15.3642 69.1237 18.5153 71.2362 22.0268 72.7031C25.664 74.2288 29.5191 75 33.5 75C37.4808 75 41.3359 74.2288 44.9731 72.7115C48.476 71.2531 51.6613 69.1262 54.3511 66.4496C57.0664 63.7672 59.1951 60.632 60.6785 57.1532C62.2182 53.5501 63.0081 49.6711 62.9999 45.7527C62.9999 41.662 62.1619 37.6886 60.4941 33.9415Z",
    fill: "url(#paint0_linear_2_60)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_60",
    x: 0,
    y: 0,
    width: 67,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_60"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_60",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_60",
    x1: 33.5,
    y1: 0,
    x2: 33.5,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94FAB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28974A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.d8f42df2.svg";
export { ForwardRef as ReactComponent };